import Service from './Service';
/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
const statusFatura = {
  SEM_DATA: 'sem_data',
  COM_AUDITORIA_AUTOMATICA: 'com_auditoria_automatica',
  EM_AUDITORIA: 'em_auditoria',
  AGUARDANDO_LIBERACAO: 'aguardando_liberacao',
  CANCELADO: 'cancelado',
  LIBERADO_PARA_PAGAMENTO: 'liberado_para_pagamento',
  PAGAMENTO_EFETUADO: 'pagamento_efetuado',
  ENCERRADO_SEM_PAGAMENTO: 'encerrado_sem_pagamento',
  EM_AVALIACAO_CNU: 'em_avaliacao_cnu',
  AVALIACAO_CNU_FINALIZADA: 'avaliacao_cnu_finalizada'
};
class FaturaService extends Service {
  /**
 * FATURAS SEM DATA
 * **/

  async consultarTodasAsFaturasSemData () {
    let faturas = [];
    let result = await this.getFaturaApi().consultarLotesPorEstadoProtocolo(statusFatura.SEM_DATA);
    result.map(res => {
      const { codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado, dtaRecebimentoProtocolo } = res;
      faturas.push(Object.values({ codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado, dtaRecebimentoProtocolo }));
    });
    return faturas;
  }

  async salvarDtaRecebimentoProcessoFisicoEmLote (codLoteGuias, data) {
    let result = await this.getFaturaApi().salvarDtaRecebimentoProcessoFisicoEmLote(codLoteGuias, data);
    return result;
  }

  /**
 * FATURAS SEM AUDITORIA MANUALs
 * **/
  async consultarSemAuditoriaManual () {
    let faturas = [];
    const brancoDetalhar = '';
    let result = await this.getFaturaApi().consultarLotesPorEstadoProtocolo(statusFatura.COM_AUDITORIA_AUTOMATICA);

    result.map(res => {
      const { codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, indReapresentacao, labelNomTipoGuia, dtaRecebimentoProcessoFisico, valTotalProcessado, valTotalGlosado, valTotalLiberado } = res;
      faturas.push(Object.values({ codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, indReapresentacao, labelNomTipoGuia, dtaRecebimentoProcessoFisico, valTotalProcessado, valTotalGlosado, valTotalLiberado, brancoDetalhar }));
    });
    return faturas;
  }

  /**
 * FATURAS EM AUDITORIA MANUAL
 * **/
  async consultarFaturasEmAuditoria () {
    let faturas = [];
    const branco = '';
    let result = await this.getFaturaApi().consultarLotesPorEstadoProtocolo(statusFatura.EM_AUDITORIA);
    result.map(res => {
      const { codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado, qtdeGuiasJaAuditadas } = res;
      faturas.push(Object.values({ codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado, qtdeGuiasJaAuditadas, branco }));
    });
    return faturas;
  }

  async desfazerFaturasEmLote (lotes) {
    let result = await this.getFaturaApi().desfazerFaturasEmLote(lotes);
    return result;
  }

  async finalizarFaturasEmLote (lotes) {
    let result = await this.getFaturaApi().finalizarFaturasEmLote(lotes);
    return result;
  }

  async auditarAutomaticamenteFaturasEmLote (lotes) {
    let result = await this.getFaturaApi().auditarAutomaticamenteFaturasEmLote(lotes);
    return result;
  }

  async auditarFaturasEmLote (lotes) {
    let result = await this.getFaturaApi().auditarFaturasEmLote(lotes);
    return result;
  }

  /**
* FATURAS AGUARDANDO LIBERACAO
* **/
  async consultarTodasAsFaturasAguardandoLiberacao () {
    let faturas = [];
    const branco = '';
    let result = await this.getFaturaApi().consultarLotesPorEstadoProtocolo(statusFatura.AGUARDANDO_LIBERACAO);
    result.map(res => {
      const { codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado } = res;
      faturas.push(Object.values({ codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado, branco }));
    });
    return faturas;
  }

  async liberarFaturasEmLote (lotes) {
    let result = await this.getFaturaApi().liberarFaturasEmLote(lotes);
    return result;
  }

  async negarAuditoriaEmLote (lotes) {
    let result = await this.getFaturaApi().negarAuditoriaEmLote(lotes);
    return result;
  }

  /**
  * FATURAS LIBERADAS PARA PAGAMENTO
  * **/
  async consultarTodasAsFaturasLiberadasParaPagamento () {
    let faturas = [];
    const branco = '';
    let result = await this.getFaturaApi().consultarLotesPorEstadoProtocolo(statusFatura.LIBERADO_PARA_PAGAMENTO);
    result.map(res => {
      const { codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado } = res;
      faturas.push(Object.values({ codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado, branco }));
    });
    return faturas;
  }
  /**
  * FATURAS EM AVALIAÇÃO CNU
  * **/
  async consultarFaturasEmAvaliacaoCNU () {
    let faturas = [];
    const branco = '';
    let result = await this.getFaturaApi().consultarLotesPorEstadoProtocolo(statusFatura.EM_AVALIACAO_CNU);
    result.map(res => {
      const { codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado, qtdeGuiasJaAvaliadasCNU, indPossuiGlosaRejeitadaCnu } = res;
      faturas.push(Object.values({ codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado, qtdeGuiasJaAvaliadasCNU, indPossuiGlosaRejeitadaCnu, branco }));
    });
    return faturas;
  }
  async finalizarAvaliacaoFaturasCNU (lotes) {
    let result = await this.getFaturaApi().finalizarAvaliacaoFaturasCNU(lotes);
    return result;
  }
  async devolverFaturasTstEmLote (lotes) {
    let result = await this.getFaturaApi().devolverFaturasTstEmLote(lotes);
    return result;
  }
  /**
  * FATURAS AVALIAÇÃO CNU FINALIZADA
  * **/
  async consultarFaturasAvaliacaoCNUFinalizada () {
    let faturas = [];
    const branco = '';
    let result = await this.getFaturaApi().consultarLotesPorEstadoProtocolo(statusFatura.AVALIACAO_CNU_FINALIZADA);
    result.map(res => {
      const { codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado } = res;
      faturas.push(Object.values({ codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado, branco }));
    });
    return faturas;
  }
  async enviarFaturasCnuEmLote (lotes) {
    let result = await this.getFaturaApi().enviarFaturasCnuEmLote(lotes);
    return result;
  }

  /**
  * FATURAS RECEBIDAS
  * **/

  async consultarTodasAsFaturasPorPrestadorOuCodigoFatura (seqPrestador, codFatura) {
    let faturas = [];
    var bolRelatorioGlosa = '';
    var tipoMenu = '';
    let result = await this.getFaturaApi().consultarTodasAsFaturasPorPrestadorOuCodigoFatura(seqPrestador, codFatura);
    result.map(res => {
      const { codLoteGuia, qtdeGuias, dtaRecebimentoProtocolo, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado, situacao, indCancelado, dtaRecebimentoProcessoFisico, motivoCancelamento } = res;
      bolRelatorioGlosa = valTotalGlosado > 0;
      if (indCancelado === 'S' && bolRelatorioGlosa) {
        tipoMenu = 'EXCLUIR_E_GLOSA';
      }
      if (indCancelado !== 'S' && bolRelatorioGlosa) {
        tipoMenu = 'GLOSA';
      }
      if (indCancelado === 'S' && !bolRelatorioGlosa) {
        tipoMenu = 'EXCLUIR';
      }
      if (indCancelado !== 'S' && !bolRelatorioGlosa) {
        tipoMenu = 'SEM_MENU';
      }
      faturas.push(Object.values({ codLoteGuia, qtdeGuias, dtaRecebimentoProtocolo, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado, situacao, tipoMenu, indCancelado, dtaRecebimentoProcessoFisico, motivoCancelamento }));
    });
    return faturas;
  }

  async consultarFaturasPorNumGuiaPrestador (numGuiaPrestador) {
    // let faturas = [];
    // let result =
    // result.map(res => {
    //   const { codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado, dtaRecebimentoProcessoFisico, situacao, indCancelado, motivoCancelamento, dtaRecebimentoProtocolo } = res;
    //   faturas.push(Object.values({ codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado, dtaRecebimentoProcessoFisico, dtaRecebimentoProtocolo, situacao, tipoMenu, brancoDetalhar, indCancelado, motivoCancelamento }));
    // });
    // return faturas || [];
    let faturas = [];
    const brancoDetalhar = '';
    var bolRelatorioGlosa = '';
    var tipoMenu = '';
    let result = await this.getFaturaApi().consultarFaturasPorNumGuiaPrestador(numGuiaPrestador);
    result.map(res => {
      const { codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado, dtaRecebimentoProcessoFisico, situacao, indCancelado, motivoCancelamento, dtaRecebimentoProtocolo } = res;
      bolRelatorioGlosa = valTotalGlosado > 0;
      if (indCancelado === 'S' && bolRelatorioGlosa) {
        tipoMenu = 'EXCLUIR_E_GLOSA';
      }
      if (indCancelado !== 'S' && bolRelatorioGlosa) {
        tipoMenu = 'GLOSA';
      }
      if (indCancelado === 'S' && !bolRelatorioGlosa) {
        tipoMenu = 'EXCLUIR';
      }
      if (indCancelado !== 'S' && !bolRelatorioGlosa) {
        tipoMenu = 'SEM_MENU';
      }
      faturas.push(Object.values({ codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado, dtaRecebimentoProcessoFisico, dtaRecebimentoProtocolo, situacao, tipoMenu, brancoDetalhar, indCancelado, motivoCancelamento }));
    });
    return faturas || [];
  }

  async consultarFaturasPorPrestadorCodigoStatus (seqPrestador, numCarteiraTst = 'vazio', codFatura, numGuiaPrestador = 'vazio', numGuiaOperadora = 'vazio', txtSenhaAutorizacao = 'vazio', codEstado) {
    let faturas = [];
    const brancoDetalhar = '';
    var bolRelatorioGlosa = '';
    var tipoMenu = '';
    let result = await this.getFaturaApi().consultarFaturasPorPrestadorCodigoStatus(seqPrestador, numCarteiraTst || 'vazio', codFatura, numGuiaPrestador || 'vazio', numGuiaOperadora || 'vazio', txtSenhaAutorizacao || 'vazio', codEstado);
    result.map(res => {
      const { codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado, dtaRecebimentoProcessoFisico, situacao, indCancelado, motivoCancelamento, dtaRecebimentoProtocolo } = res;
      bolRelatorioGlosa = valTotalGlosado > 0;
      if (indCancelado === 'S' && bolRelatorioGlosa) {
        tipoMenu = 'EXCLUIR_E_GLOSA';
      }
      if (indCancelado !== 'S' && bolRelatorioGlosa) {
        tipoMenu = 'GLOSA';
      }
      if (indCancelado === 'S' && !bolRelatorioGlosa) {
        tipoMenu = 'EXCLUIR';
      }
      if (indCancelado !== 'S' && !bolRelatorioGlosa) {
        tipoMenu = 'SEM_MENU';
      }
      faturas.push(Object.values({ codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado, dtaRecebimentoProcessoFisico, dtaRecebimentoProtocolo, situacao, tipoMenu, brancoDetalhar, indCancelado, motivoCancelamento }));
    });
    return faturas;
  }

  /**
* LOTES
* **/

  async consultarLote (codLote) {
    let result = await this.getFaturaApi().consultarLote(codLote);
    return result;
  }

  async cancelarFaturasEmLote (lotes, motivo) {
    let result = await this.getFaturaApi().cancelarFaturasEmLote(lotes, motivo);
    return result;
  }

  async excluirFaturasEmLote (lotes, cpfCnpj) {
    let result = await this.getFaturaApi().excluirFaturasEmLote(lotes, cpfCnpj);
    return result;
  }

  async consultarCodigoENumeroFaturas () {
    let faturas = await this.getFaturaApi().consultarCodigoENumeroFaturas();

    return faturas || [];
  }
}

export default FaturaService;
